function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1414_9943)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.6 24.2C15.3614 24.2 17.6 21.9614 17.6 19.2C17.6 16.4385 15.3614 14.2 12.6 14.2C9.83855 14.2 7.59998 16.4385 7.59998 19.2C7.59998 21.9614 9.83855 24.2 12.6 24.2Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.2 24.2C46.9614 24.2 49.2 21.9614 49.2 19.2C49.2 16.4385 46.9614 14.2 44.2 14.2C41.4386 14.2 39.2 16.4385 39.2 19.2C39.2 21.9614 41.4386 24.2 44.2 24.2Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6 19.2H39.2",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2 19.2H50.4L55.4 17.9C56.2 17.7 56.8 16.9 56.8 16V14.5C56.8 14.1 56.7 13.8 56.4 13.5L56 13.1C55.7 12.8 55.6 12.5 55.6 12.1V11.3C55.6 10.5 55.2 9.79998 54.5 9.49998C52.6 8.59998 50.6 7.99998 48.6 7.69998L43.6 6.89998L35 1.99998C33.4 1.09998 31.5 0.599976 29.6 0.599976H20.6C18.6 0.599976 16.5 1.09998 14.7 2.09998L7 5.99998L3.5 6.49998C2.4 6.59998 1.6 7.49998 1.6 8.59998V10.6C1.6 11.2 1.5 11.7 1.2 12.2L0.9 12.9C0.6 13.4 0.5 13.9 0.5 14.5V16C0.5 16.9 1.1 17.8 2 18L4 18.6C5.4 19 6.1 19.2 7.6 19.2",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.59998 8.59998H3.79998C4.19998 8.59998 4.39998 8.99998 4.29998 9.29998L3.89998 10.5C3.79998 10.7 3.59998 10.9 3.39998 10.9H1.59998",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.7 9.29997L52.9 10.5C53.5 10.7 53.8 11.2 53.8 11.8V13.1L49.9 11.6L49.1 9.99997C48.9 9.59997 49.3 9.19997 49.7 9.29997Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3 6.60002L14.8 4.00002C16.6 3.00002 18.6 2.40002 20.7 2.40002H24.1V7.50002L10.3 6.60002Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.2 2.40002V7.50002H40.5L34.9 3.90002C33.3 2.90002 31.5 2.40002 29.7 2.40002H27.2Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.2 9.90002H29.5",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4 14.7L35.9 11.7",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.1 13.2L38.6 12.8",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.8 14.1L35.5 13.6",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.1 15.8L31.8 14.7",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.8 16.4L37.7 15",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1414_9943"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.2,
  height: 24.7,
  fill: "white"
})));
function SvgIcnCapBodyDamages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 25,
    viewBox: "0 0 58 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCapBodyDamages);
export default __webpack_public_path__ + "static/media/icn-cap-body-damages.ded7095942ad7079e97ee3acaae8e795.svg";
export { ForwardRef as ReactComponent };